import { FeatureFlagService } from '@delta-defense/feature-flag-service';
import { FeatureFlags } from '../core/enums/featureFlags';
import { Transaction } from '../core/domain/transaction/transaction';
import { elegantEnabled } from './elegantEnabled';

const passwordPostCheckoutFunnelWhitelist = ['2813'];

export const passwordPostCheckoutIsEnabled = (
	locationSearch: string,
	funnelId = Transaction.Instance().Data.funnelId || '',
	features = FeatureFlagService.Instance()
): boolean =>
	passwordPostCheckoutFunnelWhitelist.includes(funnelId) ||
	features.IsEnabled(FeatureFlags.PasswordPostCheckout) ||
	elegantEnabled(locationSearch);
